import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import CombinedProgress from 'legacy/src/components/assignment/components/CombinedProgress';
import { getPriorStudentsSubdir } from 'legacy-src/utility/utils';

const ProgressBarPopover = ({ progress, assignment, routes, subjectId }) => {
  const hasStudents = assignment.students && assignment.students.length > 0;
  let assignmentProgress = { ...progress };

  if (!hasStudents) {
    // set the not started for the progress to -1 see StackBar.js for rendering 0 value in bar
    assignmentProgress = {
      ...assignmentProgress,
      notStarted: -1,
      not_started: -1,
    };
  }

  const assignmentProgressLink = `/${subjectId}/assignments/progress/${
    assignment.id
  }${getPriorStudentsSubdir(routes)}`;

  return (
    <Link to={assignmentProgressLink}>
      <CombinedProgress
        data-test-locked-bar
        isSmall
        isLocked={false}
        progress={assignmentProgress}
        showLabels={false}
        className="progress-bar"
        showMessageOnBar
      />
    </Link>
  );
};

ProgressBarPopover.displayName = 'ProgressBarPopover';
ProgressBarPopover.defaultProps = {
  progress: {},
};
ProgressBarPopover.propTypes = {
  progress: PropTypes.shape({
    not_started: PropTypes.number,
    started: PropTypes.number,
    watched: PropTypes.number,
    ready_to_score: PropTypes.number,
  }),
};
export default ProgressBarPopover;
